import { render, staticRenderFns } from "./Actionplan.vue?vue&type=template&id=3f084c6d&"
import script from "./Actionplan.vue?vue&type=script&lang=js&"
export * from "./Actionplan.vue?vue&type=script&lang=js&"
import style0 from "./Actionplan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports